(function () {
  const initCounter = (el) => {
    if (!el || el.hasAttribute('data-counter-static') || el.dataset.counterInitialized === 'true') {
      return;
    }

    const target = parseInt(el.dataset.counter, 10);
    if (Number.isNaN(target)) return;

    el.dataset.counterInitialized = 'true';

    const suffix = el.dataset.suffix || '';
    const useCommas = el.dataset.commas !== 'false';
    const duration = parseInt(el.dataset.duration, 10) || 2000;
    const locale = document.documentElement.lang || undefined;

    const format = (value) => {
      const n = Math.round(value);
      const body = useCommas ? n.toLocaleString(locale) : String(n);
      return `${body}${suffix}`;
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = format(target);
      return;
    }

    let started = false;
    let rafId;

    const start = () => {
      if (started) return;
      started = true;

      const startTime = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - (1 - progress) ** 3;
        el.textContent = format(target * eased);
        if (progress < 1) {
          rafId = requestAnimationFrame(tick);
        } else {
          el.textContent = format(target);
        }
      };

      el.textContent = format(0);
      rafId = requestAnimationFrame(tick);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            start();
            observer.disconnect();
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

      observer.observe(el);

      requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          start();
          observer.disconnect();
        }
      });
    } else {
      start();
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('.st-stats__num[data-counter]').forEach(initCounter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initAll(event.target);
  });
})();
